<div class="edit-toolbar"  [attr.data-theme]="'light'">
  <button class="edit-btn" (click)="onEdit()">
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24">
      <path fill="#fff" d="M19.6 4.34a2.13 2.13 0 0 0-3 0l-9.19 9.19a2 2 0 0 0-.53.93l-1.07 4.28a1 1 0 0 0 1.21 1.21l4.28-1.07a2 2 0 0 0 .93-.53l9.19-9.19a2.13 2.13 0 0 0 0-3Zm-9.27 10.27-2.23.56.56-2.23 6.84-6.84 1.67 1.67-6.84 6.84Zm8.1-8.09 1.09 1.09a.13.13 0 0 1 0 .18l-.88.88-1.27-1.27.88-.88a.13.13 0 0 1 .18 0Z"/>
    </svg>
    Edytuj slider
  </button>
  <button class="edit-btn" (click)="onMove('up')">
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24">
      <path fill="#fff" d="M12 5.83 18.17 12l1.41-1.41L12 3 4.41 10.59 5.83 12 12 5.83Z"/>
      <path fill="#fff" d="M5 19h14v-2H5v2Z"/>
    </svg>
    Przenieś wyżej
  </button>
  <button class="edit-btn" (click)="onMove('down')">
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24">
      <path fill="#fff" d="m12 18.17-6.17-6.17-1.41 1.41L12 21l7.59-7.59-1.41-1.41L12 18.17Z"/>
      <path fill="#fff" d="M19 5H5v2h14V5Z"/>
    </svg>
    Przenieś niżej
  </button>
  <button class="edit-btn" (click)="onRemove()">
    <svg width="18" height="18" fill="none" viewBox="0 0 24 24">
      <path fill="#fff" d="M7 21a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V7H7v14ZM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4Z"/>
    </svg>
    Usuń element
  </button>
</div>
